
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"contactUs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"site"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"section"},"value":{"kind":"StringValue","value":"contactUs","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"site"},"value":{"kind":"Variable","name":{"kind":"Name","value":"site"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contactUs_contactUs_Entry"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"headingTextPrimary"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"headingTextSecondary"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"headingTextTertiary"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"linkToPanelId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"backgroundImage"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"headline"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"description"},"name":{"kind":"Name","value":"shortText"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"address"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"postalAddress"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fax"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contacts"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"pageContent"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Row"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticlesBlock"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InformationGuidesBlock"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FaqsBlock"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TestimonialBlock"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"HomeCareServices"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Highlight"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Videos"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SalesFormCta"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AmenitiesBlock"},"directives":[]}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Contacts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contacts_contactsSection_BlockType"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"headline"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"description"},"name":{"kind":"Name","value":"simpleText"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"children"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contact"},"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Contact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contacts_contact_BlockType"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uid"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"title"},"name":{"kind":"Name","value":"customTitle"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"location"},"name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phone"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":1032}};
    doc.loc.source = {"body":"#import \"@/graphql/PageContent.graphql\"\n\nquery contactUs($site: [String]) {\n  entry(section: \"contactUs\", site: $site) {\n    ... on contactUs_contactUs_Entry {\n      __typename\n      headingTextPrimary\n      headingTextSecondary\n      headingTextTertiary\n      linkToPanelId\n      backgroundImage {\n        url\n      }\n      headline\n      description: shortText\n      address {\n        address\n      }\n      postalAddress\n      fax\n      contacts {\n        ...Contacts\n      }\n\n      pageContent {\n        ...Row\n        ...ArticlesBlock\n        ...InformationGuidesBlock\n        ...FaqsBlock\n        ...TestimonialBlock\n        ...HomeCareServices\n        ...Highlight\n        ...Videos\n        ...SalesFormCta\n        ...AmenitiesBlock\n      }\n    }\n  }\n}\n\nfragment Contacts on contacts_contactsSection_BlockType {\n  __typename\n  uid\n  headline\n  description: simpleText\n  children {\n    ...Contact\n  }\n}\n\nfragment Contact on contacts_contact_BlockType {\n  __typename\n  uid\n  title: customTitle\n  location: description\n  phone\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("@/graphql/PageContent.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["contactUs"] = oneQuery(doc, "contactUs");
        
